import React, { Component } from 'react';
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import "ag-grid-enterprise";
import { CommonValidationMessages } from '../../utils/Messages';

// Register all Community features
ModuleRegistry.registerModules([AllCommunityModule]);

class ItemWiseStockDetailReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isTable2Expanded: false,
            isTable3Expanded: false,
            rowData: [
                { invoice_no: "INV001", invoice_date: "2025-01-01", vendor: "Vendor A", gst_no: "GST123456", invoice_from: "City A", total_qty: 10, gross_amount: 1000, taxble_amt: 900, tax_sales_18: 162, input_sgst_9: 81, input_cgst_9: 81, tax_sales_12: 108, input_sgst_6: 54, input_cgst_6: 54, tax_sales_5: 45, input_sgst_2_5: 22.5, input_cgst_2_5: 22.5, tax_sales_28: 252, input_sgst_14: 126, input_cgst_14: 126, ogs_sales_18: 162, input_igst_12: 108, extra_charges: 50, stock_transfer: "Yes", manually_invoice: "No" },
                { invoice_no: "INV002", invoice_date: "2025-01-02", vendor: "Vendor B", gst_no: "GST654321", invoice_from: "City B", total_qty: 15, gross_amount: 1500, taxble_amt: 1350, tax_sales_18: 243, input_sgst_9: 121.5, input_cgst_9: 121.5, tax_sales_12: 162, input_sgst_6: 81, input_cgst_6: 81, tax_sales_5: 67.5, input_sgst_2_5: 33.75, input_cgst_2_5: 33.75, tax_sales_28: 378, input_sgst_14: 189, input_cgst_14: 189, ogs_sales_18: 243, input_igst_12: 162, extra_charges: 75, stock_transfer: "No", manually_invoice: "Yes" },
                { invoice_no: "INV003", invoice_date: "2025-01-03", vendor: "Vendor C", gst_no: "GST789012", invoice_from: "City C", total_qty: 8, gross_amount: 800, taxble_amt: 720, tax_sales_18: 129.6, input_sgst_9: 64.8, input_cgst_9: 64.8, tax_sales_12: 86.4, input_sgst_6: 43.2, input_cgst_6: 43.2, tax_sales_5: 36, input_sgst_2_5: 18, input_cgst_2_5: 18, tax_sales_28: 201.6, input_sgst_14: 100.8, input_cgst_14: 100.8, ogs_sales_18: 129.6, input_igst_12: 86.4, extra_charges: 40, stock_transfer: "Yes", manually_invoice: "No" },
                { invoice_no: "INV004", invoice_date: "2025-01-04", vendor: "Vendor D", gst_no: "GST345678", invoice_from: "City D", total_qty: 20, gross_amount: 2000, taxble_amt: 1800, tax_sales_18: 324, input_sgst_9: 162, input_cgst_9: 162, tax_sales_12: 216, input_sgst_6: 108, input_cgst_6: 108, tax_sales_5: 90, input_sgst_2_5: 45, input_cgst_2_5: 45, tax_sales_28: 504, input_sgst_14: 252, input_cgst_14: 252, ogs_sales_18: 324, input_igst_12: 216, extra_charges: 100, stock_transfer: "No", manually_invoice: "Yes" },
                { invoice_no: "INV005", invoice_date: "2025-01-05", vendor: "Vendor E", gst_no: "GST987654", invoice_from: "City E", total_qty: 12, gross_amount: 1200, taxble_amt: 1080, tax_sales_18: 194.4, input_sgst_9: 97.2, input_cgst_9: 97.2, tax_sales_12: 129.6, input_sgst_6: 64.8, input_cgst_6: 64.8, tax_sales_5: 54, input_sgst_2_5: 27, input_cgst_2_5: 27, tax_sales_28: 302.4, input_sgst_14: 151.2, input_cgst_14: 151.2, ogs_sales_18: 194.4, input_igst_12: 129.6, extra_charges: 60, stock_transfer: "Yes", manually_invoice: "No" },
            ],
            colDefs: [
                {
                    field: "invoice_no",
                    headerName: "Invoice no",
                    filter: true,
                    floatingFilter: true,
                    width: 150,
                },
                {
                    field: "invoice_date",
                    headerName: "Invoice date",
                    filter: true,
                    floatingFilter: true,
                    width: 200,
                },
                {
                    field: "vendor",
                    headerName: "Vendor",
                    filter: true,
                    floatingFilter: true,
                    width: 200,
                },
                {
                    field: "gst_no",
                    headerName: "GST no",
                    filter: true,
                    floatingFilter: true,
                    width: 200,
                },
                {
                    field: "invoice_from",
                    headerName: "Invoice From",
                    filter: true,
                    floatingFilter: true,
                    width: 200,
                },
                {
                    field: "total_qty",
                    headerName: "Total qty",
                    filter: true,
                    floatingFilter: true,
                    width: 100,
                },
                {
                    field: "gross_amount",
                    headerName: "Gross amount",
                    filter: true,
                    floatingFilter: true,
                    width: 100,
                },
                {
                    field: "taxble_amt",
                    headerName: "Taxble amt",
                    filter: true,
                    floatingFilter: true,
                    width: 100,
                },
                {
                    field: "tax_sales_18",
                    headerName: "Tax sales 18%",
                    filter: true,
                    floatingFilter: true,
                    width: 100,
                },
                {
                    field: "input_sgst_9",
                    headerName: "Input SGST 9%",
                    filter: true,
                    floatingFilter: true,
                    width: 100,
                },
                {
                    field: "input_cgst_9",
                    headerName: "Input CGST 9%",
                    filter: true,
                    floatingFilter: true,
                    width: 100,
                },
                {
                    field: "tax_sales_12",
                    headerName: "Tax sales 12%",
                    filter: true,
                    floatingFilter: true,
                    width: 100,
                },
                {
                    field: "input_sgst_6",
                    headerName: "Input SGST 6%",
                    filter: true,
                    floatingFilter: true,
                    width: 100,
                },
                {
                    field: "input_cgst_6",
                    headerName: "Input CGST 6%",
                    filter: true,
                    floatingFilter: true,
                    width: 100,
                },
                {
                    field: "tax_sales_5",
                    headerName: "Tax sales 5%",
                    filter: true,
                    floatingFilter: true,
                    width: 100,
                },
                {
                    field: "input_sgst_2_5",
                    headerName: "Input SGST 2.5%",
                    filter: true,
                    floatingFilter: true,
                    width: 100,
                },
                {
                    field: "input_cgst_2_5",
                    headerName: "Input CGST 2.5%",
                    filter: true,
                    floatingFilter: true,
                    width: 100,
                },
                {
                    field: "tax_sales_28",
                    headerName: "Tax sales 28%",
                    filter: true,
                    floatingFilter: true,
                    width: 100,
                },
                {
                    field: "input_sgst_14",
                    headerName: "Input SGST 14%",
                    filter: true,
                    floatingFilter: true,
                    width: 100,
                },
                {
                    field: "input_cgst_14",
                    headerName: "Input CGST 14%",
                    filter: true,
                    floatingFilter: true,
                    width: 100,
                },
                {
                    field: "ogs_sales_18",
                    headerName: "OGS sales 18%",
                    filter: true,
                    floatingFilter: true,
                    width: 100,
                },
                {
                    field: "input_igst_12",
                    headerName: "Input IGST 12%",
                    filter: true,
                    floatingFilter: true,
                    width: 100,
                },
                {
                    field: "extra_charges",
                    headerName: "Extra charges",
                    filter: true,
                    floatingFilter: true,
                    width: 150,
                },
                {
                    field: "stock_transfer",
                    headerName: "Stock transfer",
                    filter: true,
                    floatingFilter: true,
                    width: 100,
                },
                {
                    field: "manually_invoice",
                    headerName: "Manually invoice",
                    filter: true,
                    floatingFilter: true,
                    width: 100,
                },
            ],
            requestDetails: {
                fromDate: "",
                toDate: "",
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                fromDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "from date"
                        ),
                    }
                ],
                toDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "to date"
                        ),
                    }
                ],
            },
            paginationPageSize: 50,
            rowHeight: 40,
        };
    }

    render() {
        return (
            <div className='item-wise-stock-detail-report'>
                <div className="data-display">
                    <div className="data-display-inner">
                        <div className='search-grp bg-white shadow-normalShadow rounded-[10px] p-[10px] w-[60%] mb-[10px]'>
                            <p className='mb-[5px] font-semibold text-blue text-[16px]'>Select details</p>
                            <div className='item-set flex gap-[15px]'>
                                <div className='item-grp w-full flex gap-[15px]'>
                                    <div className='input-set w-[30%] grid gap-[10px]'>
                                        <div className='input-grp w-full'>
                                            <label>From date</label>
                                            <input type='date' className={`px-[10px] py-[5px] ${this.state.validState?.error?.fromDate !== undefined ? "error" : ""}`} />
                                        </div>
                                        <div className='input-grp w-full'>
                                            <label>To date</label>
                                            <input type='date' className={`px-[10px] py-[5px] ${this.state.validState?.error?.toDate !== undefined ? "error" : ""}`} />
                                        </div>
                                    </div>
                                    <div className='input-set w-[30%] grid gap-[10px] items-end'>
                                        <div className='input-grp w-full h-fit border bg-lightBlue border-[#D8E0F0] mt-[18.8px] px-[10px] py-[8px] rounded-[5px] flex items-center gap-[5px]'>
                                            <label className='radio-button w-full'>
                                                <input type='radio' id='all' name='record-selection' />
                                                <span className='custom-radio'></span>
                                                All records
                                            </label>
                                        </div>
                                        <div className='input-grp w-full h-fit border bg-lightBlue border-[#D8E0F0] mt-[18.8px] px-[10px] py-[8px] rounded-[5px] flex items-center gap-[5px]'>
                                            <label className='radio-button w-full'>
                                                <input type='radio' id='selection' name='record-selection' />
                                                <span className='custom-radio'></span>
                                                Selection wise
                                            </label>
                                        </div>
                                    </div>
                                    <div className='input-set w-[40%] grid gap-[10px]'>
                                        <div className='input-grp w-full'>
                                            <label>Select type</label>
                                            <select className='custom-select'>
                                                <option>Item group</option>
                                                <option>Item group 1</option>
                                            </select>
                                        </div>
                                        <div className='input-grp w-full'>
                                            <label>Select acc. head</label>
                                            <select className='custom-select'>
                                                <option>Me</option>
                                                <option>You</option>
                                                <option>He</option>
                                                <option>She</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className='btn-grp'>
                                    <button className='prm-btn mt-[13.61px]'>Search</button>
                                </div>
                            </div>
                        </div>
                        <div className="table w-full cursor-default bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 h-[64.8vh] w-full px-[1px] rounded-[5px]">
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Item wise stock detail report</h1>
                                </div>
                                {/* <AgGridReact
                                    rowData={this.state.rowData} // Pass row data
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs} // Pass column definitions
                                    pagination={true} // Enable pagination
                                    paginationPageSize={this.state.paginationPageSize}
                                    rowSelection={this.rowSelection}
                                /> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default ItemWiseStockDetailReport;